'use client'
import { useTranslations } from 'next-intl'

import { useUser } from '@auth0/nextjs-auth0'
// import clsx from 'clsx'
import { getUserInitials } from '@/helpers/content'

import type { ButtonBaseProps } from '@/components/atoms/Button/Button.types'
import { ButtonLabel } from '@/components/atoms/Typography'

import DropDown from '@/components/atoms/Dropdown'

import { loggedMenu } from '@/fixtures/menu'
import styles from './HeaderMenuLogged.module.scss'
import useIsMobile from '@/hooks/useIsMobile'

const LoggedMenuUl = () => {
  const t = useTranslations('General')
  return loggedMenu.map((link) => (
    <li key={link.label}>
      <a
        translate='no'
        {...link}
      >
        <ButtonLabel>{t(link.label)}</ButtonLabel>
      </a>
    </li>
  ))
}

const HeaderMenuLogged = () => {
  const { user, isLoading } = useUser()
  const isMobile = useIsMobile()
  const userLogged = !!user && !isLoading
  if (!userLogged) return <></>

  return userLogged && !!isMobile ? (
    <ul className={styles.loggedMenuUl}>
      <LoggedMenuUl />
    </ul>
  ) : (
    <DropDown
      className={styles.loggedMenu}
      trigger={getUserInitials(user?.name || 'User')}
      triggerProps={
        {
          variant: 'primary',
          theme: 'dark',
          autoWidth: true,
          translate: 'no',
          className: styles.loggedMenuTrigger,
          css: { textTransform: 'uppercase' },
        } as ButtonBaseProps
      }
    >
      <LoggedMenuUl />
    </DropDown>
  )
}

export default HeaderMenuLogged
